import Link from 'next/link';
import Image from 'next/image';
import { imgix } from '@/shared/utils/utils';
import classNames from 'classnames';
import './index.less';

interface TrendingCreatorProp {
  handle: string;
  buttonText: string;
  avatarUrl: string;
  title: string;
}
const TrendingCreatorCard = ({ creator }: { creator: TrendingCreatorProp }) => {
  return (
    <Link className="trending-creator-card" href={`/s/${creator.handle}`}>
      <div className="image-container">
        <div className="avatar">
          <Image
            className={classNames('', {
              'spark-stone': !creator.avatarUrl,
            })}
            src={
              creator.avatarUrl
                ? imgix(creator.avatarUrl || '', { h: 100, dpr: 2, q: 100 })
                : '/images/spark-stone.png'
            }
            alt="avatar"
            width={100}
            height={100}
          />
        </div>
      </div>
      <div className="info-container">
        <div className="title">{creator.title || '--'}</div>
        <span className="link-to-store">
          {creator.buttonText || ''}
          <Image src="/images/next_step.png" alt="next_step" width={9} height={9} />
        </span>
      </div>
    </Link>
  );
};
export default TrendingCreatorCard;
